// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"9b27be91","496":"84446a81","513":"8e5b5f88"}[chunkId] + ".chunk.js";
};